/**
 * NavBarLogo.js
 * Styled Component for the NavBar Logo
 */
import styled from "styled-components";

// Styles
const NavBarLogo = styled.img`
    height: 30px;
    width: 30px;
    padding: 0 8px 0 0;
`

export default NavBarLogo